import { useDashboardStore } from './useDashboardStore';
import Widget from './Widget';

export default function WidgetGrid() {
  const widgets = useDashboardStore((s) => s.widgets);
  const visible = widgets.filter((w) => w.visible);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {visible.map((w, idx) => (
        <Widget
          key={w.id}
          id={w.id}
          label={w.label}
          isFirst={idx === 0}
          isLast={idx === visible.length - 1}
        />
      ))}
      {visible.length === 0 && (
        <div className="col-span-full flex flex-col items-center justify-center py-20 text-gray-400">
          <p className="text-sm">No widgets visible.</p>
          <p className="text-xs mt-1">Click "Customize" to add some.</p>
        </div>
      )}
    </div>
  );
}
